export enum EstValuationCellBlock {
  Root = 'EstValuationCell',
}
